import { isNull, isString, isUndefined } from "lodash";
import { ParsedQs } from "qs";

import Route from "./Route";

export function parseQueryParamAsEnum<T extends string>(
    enumDict: Record<string, T>,
    param: string | string[] | undefined,
    defaultValue: T,
): T {
    const value = param as T;

    return Object.values(enumDict).includes(value) ? (value as T) : defaultValue;
}

const pathArgRegex = new RegExp("^\\[([a-zA-Z0-9_]+)\\]$");

const matchRoute = (route: Route, pathname: string) => {
    const routeSegments = route.split("/");
    const segments = pathname.split("/");

    if (routeSegments.length !== segments.length) {
        // Route segments and pathname segments do not match
        return null;
    }

    const params: Record<string, string> = {};

    for (let i = 0; i < routeSegments.length; i++) {
        const routeSegment = routeSegments[i];
        const segment = segments[i];

        const argName = routeSegment.match(pathArgRegex)?.[1];

        if (argName) {
            // this is a route argument
            params[argName] = segment;
        } else if (routeSegment !== segment) {
            // Static segment mismatch
            return null;
        }
    }

    return params;
};

function isRoute(pathname: string): pathname is Route {
    return Object.values(Route).some(route => {
        return !isNull(matchRoute(route, pathname.split("?")[0]));
    });
}

export function sanitizeRedirect(value: undefined | string | ParsedQs | (string | ParsedQs)[]): Route | undefined {
    if (isUndefined(value)) {
        return;
    }

    if (!isString(value)) {
        return;
    }

    if (!isRoute(value)) {
        return;
    }

    return value;
}
